<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">门禁设备</h1>
			<el-table
			stripe
			border
			:data="tableData"
			style="width: 100%">
				<el-table-column
				type="index"
				width="80">
				</el-table-column>
				
				<el-table-column
					prop="cname"
					label="名称">
				</el-table-column>
				<el-table-column
					prop="serialno"
					label="设备编码">
				</el-table-column>
				
				<el-table-column
					prop="ip"
					label="IP地址">
				</el-table-column>
				
				<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small"
							@click="showOpen(scope.row)">远程开门
					</el-button>

					
				</template>
				</el-table-column>
			</el-table>
		</div>
		<!--开门确认-->
		<el-dialog title="提示" :visible.sync="openFlag" width="500px" >
		    <div class="userInfo">
				<p>确定进行开门操作吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="openFlag = false">取消</el-button>
			    <el-button type="primary" @click="openDoor()">确定</el-button>
			  </div>
		</el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
		showLoading: false,
		tableData: [],
		openDoorRow: {},
		openFlag: false,
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getDetail();
  	})
  },

  methods: {
	getDetail(){
		this.showLoading = true;
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/FaceManage/List",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.showLoading = false;
				this.tableData = res.data.data;
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	showOpen(row){
		this.openDoorRow = row;
		this.openFlag = true;
	},
	openDoor(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			serialno: this.openDoorRow.serialno || "",
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/GuardManage/GuardOpendoor",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.openFlag = false;
				this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/doorOperate.vue